import React, { useContext } from 'react';
import { ApiContext } from '@api/api';
import { FeaturesEnum, PermissionTypesEnum } from '@api/ringil-api.v2';
import SecuredArea from '@components/security/SecuredArea.tsx';
import { useSecuredFlag } from '@components/security/useSecuredFlag';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import BreadCrumbComponent from '@components/obsolete/BreadCrumbComponent/BreadCrumbComponent.tsx';
import Heading from '@components/ringil3/Heading/Heading.tsx';
import EmailHistoryTable from './EmailHistoryTable.tsx';

/** Mail this company sent, scoped by the backend to the caller's own company. */
const CompanyEmailHistory: React.FC = () => {
  const { cuFindEmailRecipients, cuBatchResendResolvedEmails } = useContext(ApiContext);
  const { tr } = useTranslationLgs();

  // The route enforces the same pair before this renders; declaring it here as well is what puts the
  // page's own requirement in security mode next to the menu and resend flags.
  const listFlag = useSecuredFlag('email-history-list', {
    kind: 'visibility',
    description: 'Communication history list',
    features: [FeaturesEnum.ENABLE_SENDER_EMAIL_HISTORY],
    permissions: [PermissionTypesEnum.PERMISSION_EMAIL_HISTORY_READ, PermissionTypesEnum.PERMISSION_EMAIL_HISTORY_RW],
  });

  const resendFlag = useSecuredFlag('email-history-resend', {
    kind: 'visibility',
    description: 'Resend a sent e-mail',
    permissions: [PermissionTypesEnum.PERMISSION_EMAIL_HISTORY_RW],
  });

  const title = tr('EmailHistory.pageTitle', 'Communication history');

  return (
    <>
      <BreadCrumbComponent items={[{ label: title }]} />
      <Heading title={title} headingVariant={'h1'} />
      <SecuredArea id="email-history-list" visible={listFlag} label="Communication history list" description="History of e-mails and messages sent by the company">
        <EmailHistoryTable fetchPage={cuFindEmailRecipients} resendBatch={cuBatchResendResolvedEmails} resendSecured={resendFlag} filterName="company_email_history" />
      </SecuredArea>
    </>
  );
};

export default CompanyEmailHistory;
